export default function marketplaceProductFromResponse(data) {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return null;

  if (Object.prototype.hasOwnProperty.call(data, 'id')) return data;

  const wrapped = data.product || data.item || data.data;
  if (wrapped && typeof wrapped === 'object' && !Array.isArray(wrapped)) return wrapped;

  return data;
}
